import { cn } from '@global/utils/tailwind'
import { t } from '@lingui/core/macro'
import { Button } from '@taxonomy-translation/components'
import HandIcon from 'images/hand-icon.svg'

interface FeedbackButtonProps {
  onClick: () => void
  className?: string
  extraStyle?: React.CSSProperties
}

export function FeedbackButton({ onClick, className, extraStyle }: FeedbackButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      className={cn(
        'border-[#0092F3] text-[#0092F3] hover:bg-[#0092F3] hover:text-white',
        className,
      )}
      style={{
        ...extraStyle,
      }}
    >
      <div className="flex gap-2 items-center">
        <HandIcon className="fill-current hover:fill-white" />
        <span>{t`Give feedback`}</span>
      </div>
    </Button>
  )
}
